const VerifyData = {
    // Search
    form: {
        company_name: '',
        company_phonetic: '',
        company_post_code: '',
        company_address: '',
        company_tel: '',
        login_email: '',
        company_type: '',
        // company_kind: '',
        registration_plan: 0, //0: brand, 10: shopのpersonal, 11: shopのunit , 20: showroom ・・・この4つのいずれかが入ります
    },

    res: []

}

export default VerifyData
